import PropTypes from 'prop-types'
import React from 'react'

/**
 * AppShell
 *
 * A component that provides a consistent layout for the application.
 *
 * @param {boolean} skipLayout - If true, skip layout styles.
 * @param {React.ReactNode} children - The content to be rendered inside the layout.
 * @returns {JSX.Element} - The rendered component.
 */
const AppShell = ({ children, skipLayout = false }) => {
  if (skipLayout) return children

  // Grows to fill the page column in Routes, below the nav and any banners, so the footer
  // sits at the bottom of a short page. Never shrinks: a long page runs long, and the page
  // scrolls, as it always has.
  return (
    <div className="bg-background flex w-full shrink-0 grow flex-col overflow-y-auto px-4 py-6 sm:px-6 lg:px-8">
      {children}
    </div>
  )
}

AppShell.propTypes = {
  skipLayout: PropTypes.bool,
  children: PropTypes.node.isRequired,
}

export default AppShell
